<template>
  <BaseCustomizeMetal componentCode="AN">
    <template slot="respect" slot-scope="{ text }">
      <div class="text">
        <span v-html="text.split('')[0] || ''"></span>
        <span v-html="text.split('')[1] || ''"></span>
      </div>
    </template>
  </BaseCustomizeMetal>
</template>

<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalAN",
  components: {
    BaseCustomizeMetal,
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 100px;
    left: 118px;
    @include betweenTableTablePro {
      top: 66px;
      left: 68px;
    }
    @include table {
      top: 51px;
      left: 43px;
    }
    @include phone {
      top: 42px;
      left: 29px;
    }
  }
  .templeName {
    height: 28px;
    width: 223px;
    .textContainer {
      width: 223px;
    }
  }
  .godName {
    width: 260px;
    height: 72px;
    .textContainer {
      width: 260px;
    }
  }
  .gift {
    width: 230px;
    height: 32px;
    margin: 0 17px auto auto;
    .textContainer {
      width: 230px;
    }
  }
  .respect {
    width: 46px;
    margin: 6px auto;
    .text {
      position: relative;
      span {
        position: absolute;
      }
      span:nth-child(1) {
        left: -25px;
      }
      span:nth-child(2) {
        right: -30px;
      }
    }
  }
}
</style>
